module.exports = __webpack_public_path__ + "img/64a0764.svg";